import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const SIMSI_REGISTER = "https://simsi.komisiinformasi.go.id/register";
const SIMSI = "https://simsi.komisiinformasi.go.id/";

export default function Sengketa() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Pengajuan Informasi Publik — Penyelesaian Sengketa
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Penyelesaian Sengketa
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <h2
            data-testid="sengketa-subtitle"
            className="mt-12 max-w-3xl font-display text-2xl font-semibold leading-snug text-[#0B2440] md:text-3xl"
          >
            Prosedur Penyelesaian Sengketa Informasi
          </h2>
          <ol
            data-testid="sengketa-list"
            className="mt-8 max-w-3xl list-decimal space-y-6 pl-6 text-[15px] leading-relaxed text-slate-600 marker:font-semibold marker:text-[#0B2440] md:text-base"
          >
            <li>
              Layanan informasi di LLDIKTI Wilayah VII dikelola oleh Pejabat
              Pengelola Informasi dan Dokumentasi (PPID) yaitu Kepala Bagian
              Umum dengan dibantu oleh Tim Pelaksana PPID. Unit layan
              informasi publik diselenggarakan oleh Unit Layanan Terpadu
              (ULT) di bawah koordinasi Tim Kerja Kehumasan LLDIKTI Wilayah
              VII dengan alamat di kantor LLDIKTI Wilayah VII, JL Dr. Ir. H.
              Soekarno, No. 177, Surabaya;
            </li>
            <li>
              Pemohon informasi yang telah menerima tanggapan tertulis dari
              LLDIKTI Wilayah VII dan menilai bahwa tanggapan yang diberikan
              tidak memenuhi permintaan informasi dan/atau alasan lainnya
              sesuai dengan Undang-undang Keterbukaan Informasi Publik Nomor
              14 Tahun 2008 dapat mengajukan keberatan atas tanggapan
              tersebut.{" "}
              <Link
                to="/pengajuan-keberatan"
                data-testid="sengketa-keberatan-link"
                className="font-semibold text-[#1479BF] hover:underline"
              >
                Klik disini berikut untuk melihat informasi tentang pengajuan
                keberatan;
              </Link>
            </li>
            <li>
              Bilamana atas tanggapan keberatan yang diajukan masih dinilai
              tidak memenuhi permintaan informasi dan/atau alasan lainnya
              sesuai dengan Undang-undang, maka dapat mengajukan sengketa
              informasi kepada Komisi Informasi Pusat dengan alamat Wisma BSG
              Gedung Annex Lantai 1, Jl Abd ul Muis No. 40, Jakarta Pusat
              10110 atau melalui laman berikut:{" "}
              <a
                href={SIMSI_REGISTER}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="sengketa-simsi-register-link"
                className="font-semibold text-[#1479BF] hover:underline"
              >
                simsi.komisiinformasi.go.id/register;
              </a>
            </li>
            <li>
              Sesuai ketentuan Undang-undang tersebut, jangka waktu pengajuan
              sengketa informasi selambat-lambatnya 14 (empat belas) hari
              kerja sejak diterimanya tanggapan tertulis atas keberatan yang
              disampaikan LLDIKTI Wilayah VII;
            </li>
            <li>
              Dalam waktu 14 hari kerja sejak diterimanya permohonan
              penyelesaian sengketa dari pemohon informasi, Komisi Informasi
              mulai melakukan proses penyelesaian sengketa;
            </li>
            <li>
              Proses penyelesaian sengketa informasi dapat dilakukan melalui
              jalur mediasi dan/atau sidang adjudikasi nonlitigasi paling
              lambat 100 hari kerja.
            </li>
          </ol>
          <p className="mt-10 max-w-3xl text-[15px] leading-relaxed text-slate-600 md:text-base">
            Informasi lebih lengkap mengenai penyelesaian sengketa informasi
            dapat mengunjungi laman berikut:{" "}
            <a
              href={SIMSI}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sengketa-simsi-link"
              className="font-semibold text-[#1479BF] hover:underline"
            >
              simsi.komisiinformasi.go.id/
            </a>
          </p>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
